'use client';

import { useEffect } from 'react';
import { Amplify } from 'aws-amplify';
import CognitoConfig from '../common/Cognitoconfig';
import Modal from 'react-modal';

// Polyfill for findDOMNode for semantic-ui-react compatibility with React 18+
if (typeof window !== 'undefined') {
  const ReactDOM = require('react-dom');
  if (!ReactDOM.findDOMNode) {
    ReactDOM.findDOMNode = (component) => {
      // Return null for now - this prevents the error
      // Most semantic-ui-react components will work fine without it
      return null;
    };
  }
}

// Configure Amplify once for the entire app (same pattern as pages/_app.js)
// This MUST be outside the component to run before any components try to use auth
// Guard flag ensures it only runs once even if this module is imported multiple times
let isAmplifyConfigured = false;
if (typeof window !== 'undefined' && !isAmplifyConfigured) {
  Amplify.configure(CognitoConfig);
  isAmplifyConfigured = true;
  console.log('✅ Amplify configured in app/providers.js');
}

export function AppProviders({ children }) {
  useEffect(() => {
    // Configure Amplify on client side
    if (typeof window !== 'undefined') {
      // Amplify.configure(CognitoConfig);

      // Set app element for react-modal globally
      // This is needed for accessibility
      Modal.setAppElement(document.body);
    }
  }, []);

  // If you need Apollo Client, uncomment and configure:
  // import { ApolloProvider } from '@apollo/client';
  // import client from '../common/Apolloconfig/index';
  //
  // return (
  //   <ApolloProvider client={client}>
  //     {children}
  //   </ApolloProvider>
  // );

  return <>{children}</>;
}